import type { TextTemplate } from "./TextTransformer";

interface TextTemplatePickerProps {
  templates: TextTemplate[];
  selectedTemplate: TextTemplate;
  onSelect: (template: TextTemplate) => void;
  disabled?: boolean;
}

export default function TextTemplatePicker({
  templates,
  selectedTemplate,
  onSelect,
  disabled = false,
}: TextTemplatePickerProps) {
  return (
    <div className="post-type-list">
      {templates.map((template) => (
        <button
          key={template.id}
          type="button"
          className={`post-type-chip ${
            selectedTemplate.id === template.id
              ? "post-type-chip--selected"
              : ""
          }`}
          onClick={() => onSelect(template)}
          disabled={disabled}
          title={template.description}
        >
          {template.name}
        </button>
      ))}
    </div>
  );
}